export default __webpack_public_path__ + "static/media/moma-white.ba045ba6.png";